import React, { createContext, useContext, useSyncExternalStore } from "react";
import { readHomepageBootstrap } from "../utils/homepageBootstrap";

const HomepageRenderContext = createContext(null);
const subscribe = () => () => {};
const clientSnapshot = () => false;

// A request-local public snapshot, shared by server render and first hydration.
// Never put session, booking, cart or user data in this context's HTML payload.
export function HomepageRenderProvider({ bootstrap, children }) {
  return <HomepageRenderContext.Provider value={bootstrap || null}>{children}</HomepageRenderContext.Provider>;
}

export function useHomepageHydration() {
  const bootstrap = useContext(HomepageRenderContext);
  return useSyncExternalStore(subscribe, clientSnapshot, () => Boolean(bootstrap?.rendered));
}

export function useHomepageBootstrap(pathname) {
  const bootstrap = useContext(HomepageRenderContext);
  const hydrating = useHomepageHydration();
  return hydrating && bootstrap && (!pathname || bootstrap.pathname === pathname)
    ? bootstrap : readHomepageBootstrap(pathname);
}
